import React from 'react';
import PropTypes from 'prop-types';
import useIntl from '@afosto/utils-react/intl/useIntl';
import { useSnackbar } from 'notistack';
import ChangeRouteForm from '../../ChangeRouteForm';
import FormDrawer from '@afosto/app-components-react/FormDrawer';
import { items as itemsApi } from '@afosto/order/api/Items';
import translations from './translations';

const ChangeRouteDrawer = ({ isOpen, onCancel, onSave, order, orderItem }) => {
  const intl = useIntl();
  const { enqueueSnackbar } = useSnackbar();

  const handleChangeRoute = async ({ collectRoute, deliveryRoute, quantity }) => {
    try {
      const ids = (orderItem.ids ?? []).slice(0, quantity);

      await itemsApi.setRoute(order?.id, [
        {
          item_ids: ids,
          delivery_route_id: deliveryRoute?.id ?? null,
          collect_route_id: collectRoute?.id ?? null,
        },
      ]);

      if (onSave && typeof onSave === 'function') {
        onSave();
      }

      enqueueSnackbar(intl.formatMessage(translations.feedback.routeChanged), {
        variant: 'success',
      });
    } catch (err) {
      enqueueSnackbar(intl.formatMessage(translations.feedback.routeNotChanged), {
        variant: 'error',
      });
    }
  };

  return (
    <FormDrawer
      drawerWidth="450px"
      isOpen={isOpen}
      onClose={onCancel}
      title={intl.formatMessage(translations.title)}
    >
      <ChangeRouteForm
        onCancel={onCancel}
        onSubmit={handleChangeRoute}
        order={order}
        orderItem={orderItem}
      />
    </FormDrawer>
  );
};

ChangeRouteDrawer.propTypes = {
  isOpen: PropTypes.bool,
  onCancel: PropTypes.func,
  onSave: PropTypes.func,
  order: PropTypes.object,
  orderItem: PropTypes.object,
};

ChangeRouteDrawer.defaultProps = {
  isOpen: false,
  onCancel: undefined,
  onSave: undefined,
  order: undefined,
  orderItem: undefined,
};

export default ChangeRouteDrawer;
